import { useQuery } from "@tanstack/react-query";

import { onboardingAgentNudgeApiService } from "../onboardingAgentNudgeApiService";

const ONBOARDING_AGENT_NUDGE_SUGGESTIONS_QUERY_KEY = "onboarding-agent-nudge-suggestions";

export const useOnboardingAgentNudgeSuggestionsQuery = (enabled: boolean) =>
    useQuery({
        queryKey: [ONBOARDING_AGENT_NUDGE_SUGGESTIONS_QUERY_KEY],
        queryFn: ({ signal }) => onboardingAgentNudgeApiService.getSuggestedQuestions({ cancellation: signal }),
        enabled,
        staleTime: Number.POSITIVE_INFINITY,
    });
